import { parseAgentSpecWorkspace } from "@/services/api/agentSpecs";
import type {
  AgentSpecProjectFile,
  AgentSpecPullResult,
} from "@/types/agentSpec";
import type { AgentSpecStudioNavigationResource } from "@/store/agentSpecStudio";

/** Later file sets overlay earlier ones by path (published then each host fil). */
export function mergeAgentSpecProjectFiles(
  ...fileSets: Array<ReadonlyArray<AgentSpecProjectFile> | undefined>
): AgentSpecProjectFile[] {
  const byPath = new Map<string, AgentSpecProjectFile>();
  for (const files of fileSets) {
    for (const file of files ?? []) {
      const path = file.path?.trim();
      if (!path) continue;
      byPath.set(path, file);
    }
  }
  return [...byPath.values()];
}

export function studioRevisionHasTreeResources(
  files: ReadonlyArray<AgentSpecProjectFile> | undefined,
): boolean {
  return (files ?? []).some(
    (file) =>
      file.path.includes("/workflows/") || file.path.includes("/miniapps/"),
  );
}

export function navigationResourcesFromPull(
  pull: AgentSpecPullResult | null | undefined,
): {
  workflows: AgentSpecStudioNavigationResource[];
  miniapps: AgentSpecStudioNavigationResource[];
} {
  if (!pull) return { workflows: [], miniapps: [] };
  try {
    const workspace = parseAgentSpecWorkspace(pull);
    return {
      workflows: workspace.workflows.map((item) => ({
        id: item.component_id,
        title: item.title || item.component_id,
      })),
      miniapps: workspace.miniapps.map((item) => ({
        id: item.component_id,
        title: item.title || item.component_id,
      })),
    };
  } catch {
    return { workflows: [], miniapps: [] };
  }
}
